import {css} from 'lit';
export const styles = css`:host{display:none;width:100%}:host([visible]){display:inline-flex}.step-content{display:block;width:100%}.step-content.off-step{margin-top:.5rem}::slotted(atlas-section:last-child){margin-bottom:0}@media screen and (min-width: 992px){.step-content.off-step{margin-top:2rem}}`;
export default styles;
